"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportItem = void 0;
var ExportItem;
(function (ExportItem) {
    ExportItem[ExportItem["OrderPrices"] = 0] = "OrderPrices";
    ExportItem[ExportItem["AdCustomizer"] = 1] = "AdCustomizer";
    /**
     * @deprecated Remarketing feed export is no more generated.
     * Do not remove that enum value it might broke exportRecords collection.
     */
    ExportItem[ExportItem["RemarketingFeed"] = 2] = "RemarketingFeed";
    ExportItem[ExportItem["DriversOrdersBalances"] = 3] = "DriversOrdersBalances";
    ExportItem[ExportItem["TravelAgentReport"] = 4] = "TravelAgentReport";
})(ExportItem || (exports.ExportItem = ExportItem = {}));
//# sourceMappingURL=ExportItem.js.map